<template>
  <footer-button color="primary" v-bind="$attrs" @click="$emit('click')">
    {{ $t('component.continueFooterButton.continueText') }}

    <template #append>
      <v-icon :icon="mdiArrowRight" />
    </template>
  </footer-button>
</template>

<script setup>
  import { mdiArrowRight } from '@mdi/js'
  import { useI18n } from 'vue-i18n'

  const { t } = useI18n()
  defineEmits(['click'])
</script>

<style lang="scss" scoped>
.v-btn {
  display: flex;

  & :deep(.v-btn__prepend) {
    margin-right: auto;
  }

  & :deep(.v-btn__append) {
    margin-left: auto;
  }

  & :deep(.v-btn__content) {
    margin-left: auto;
    margin-right: auto;
  }
}

</style>
